<template>

  <div class="section d-flex">

    <div class="menu_section hidden-md-and-down"></div>
    <div class="container_section">

      <v-container>

        <v-breadcrumbs :items="breadcrumbs" class="pl-0 pb-0"></v-breadcrumbs>

        <h1 class="py-10">Logs</h1>

        <AuditTrails />

      </v-container>

    </div>
    
    

  </div>

</template>

<script>

import { mapGetters } from "vuex";
import AuditTrails from '@/components/audittrails/AuditTrails' ;
// import { component as VueCodeHighlight } from 'vue-code-highlight';

export default {
  name: "Logs",
  computed: {

    ...mapGetters({
      audittrails: "audittrails/audittrails"
    })

  },
  data () {
    return {
        // date: new Date().toISOString().substr(0, 10),
        
        breadcrumbs: [
            {
                text: 'Dashboard',
                disabled: false,
                to: '/dashboard',
                exact: true
            },
            {
                text: 'Logs',
                disabled: true,
                exact: true
            },
        ]
    }

  },
  methods: {

      

  },
  components:{
    AuditTrails
    },
  created() {

        

  }

};
</script>
